'use client';

import useCriticasPaginaHook from './hook/useCriticasPaginaHook';

import PaginaPublicacaoTemplateFallback from '@/components/templates/PaginaPublicacaoTemplate/fallback';
import PaginaPublicacaoTemplate, {
  PaginaPublicacaoProps,
} from '@/components/templates/PaginaPublicacaoTemplate';
import { CriticaVisualizacao } from './components/molecules/CriticaResumoVisualizacao';
import { useRouter } from 'next/navigation';
import { formatarDuracaoConteudo } from '@/utils/formatarDuracaoConteudo';
import RecomendacoesPublicacao from '@/components/organisms/ListagemRecomendacoesPublicacao';

export default function PaginaCriticas(props: PaginaPublicacaoProps) {
  const { $tipoPagina } = props;
  const router = useRouter();
  const {
    critica,
    jsonLDPaginaCritica,
    criticaSendoCarregada,
    imagemCartazTituloCritica,
    criticasRecomendadas,
  } = useCriticasPaginaHook(props);

  if (!critica) return <PaginaPublicacaoTemplateFallback />;

  return (
    <PaginaPublicacaoTemplate
      $tipoPublicacao={$tipoPagina}
      $carregandoPublicacao={criticaSendoCarregada}
      $imagemDestaquePublicacao={critica.imagemArquivo.urlx1}
      $tituloPublicacao={critica.titulo}
      $subtituloPublicacao={critica.subtitulo}
      $tempoLeituraPublicacao={critica.tempoDeLeitura}
      $autorPublicacaoImagem={critica?.authorImage}
      $autorPublicacaoNome={critica.publicadoPor}
      $conteudoPublicacao={critica.conteudo}
      $dataPublicacao={critica?.dataNoticia}
      $jsonLDPaginaPublicacao={jsonLDPaginaCritica}
    >
      <CriticaVisualizacao
        $titulo={critica?.tituloObj?.titulo || ''}
        $autor={critica.publicadoPor}
        $nota={critica.nota}
        $imagemCartaz={imagemCartazTituloCritica}
        $data={critica?.tituloObj?.ano.toString()}
        $duracao={formatarDuracaoConteudo(
          critica.tituloObj?.duracao.toString() || '0',
        )}
        $aoClicar={() =>
          router.push(
            critica.tituloObj?.slug ? `/ficha/${critica.tituloObj.slug}` : '/',
          )
        }
        $generos={critica.tituloObj?.generos}
        $plataformas={critica.tituloObj?.plataformas}
      />
      {criticasRecomendadas?.length ? (
        <RecomendacoesPublicacao recomendacoes={criticasRecomendadas} />
      ) : null}
    </PaginaPublicacaoTemplate>
  );
}
